import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import { safeRest } from '../../utils/functions.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { EXPANDABLE_PANEL_VARIANT } from './constants.js';
import { BodyWrapper } from './styledComponents.js';

var _excluded = ["id", "ariaLabelledBy", "isExpanded", "customStyle", "children", "variant"];

var Body = function Body(_ref) {
  var id = _ref.id,
      ariaLabelledBy = _ref.ariaLabelledBy,
      isExpanded = _ref.isExpanded,
      customStyle = _ref.customStyle,
      children = _ref.children,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, _excluded);

  var safeProps = safeRest(rest);

  var _safeCustomStyle = safeCustomStyle(customStyle),
      bodyStyle = _safeCustomStyle.bodyStyle;

  return /*#__PURE__*/React.createElement(BodyWrapper, _extends({}, safeProps, {
    id: id,
    "aria-labelledby": ariaLabelledBy,
    isExpanded: isExpanded,
    variant: variant,
    bodyStyle: bodyStyle
  }), children);
};

process.env.NODE_ENV !== "production" ? Body.propTypes = {
  /** id for body wrapper */
  id: PropTypes.string,

  /** idREF for aria-labelledBy attribute */
  ariaLabelledBy: PropTypes.string,

  /** current state of expansion panel */
  isExpanded: PropTypes.bool,

  /** element for body of expandable panel */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,

  /** Which style of expandable panel to use */
  variant: PropTypes.oneOf([EXPANDABLE_PANEL_VARIANT.PRIMARY, EXPANDABLE_PANEL_VARIANT.SECONDARY]),

  /** style overrides for body wrapper */
  customStyle: PropTypes.shape({
    bodyStyle: PropTypes.object
  })
} : void 0;
Body.defaultProps = {
  id: undefined,
  ariaLabelledBy: undefined,
  isExpanded: false,
  variant: EXPANDABLE_PANEL_VARIANT.PRIMARY,
  customStyle: {
    bodyStyle: {}
  }
};
process.env.NODE_ENV !== "production" ? Body.displayName = 'Body' : void 0;
var Body$1 = Body;

export { Body$1 as default };
